import { useAuth0 } from '@auth0/auth0-react';
import config from '../config';

const { AUTH0_AUDIENCE: audience, AUTH0_SCOPE: scope } = config;

export class ApiError extends Error {
  status: number;
  data: { message: string, reason?: string };

  constructor(status: number, data: { message: string, reason?: string }) {
    super(data.message);
    this.status = status;
    this.data = data;
  }
}

async function fetchWithTokenAsync(getAccessTokenSilently, ...args: any) {
  const token = await getAccessTokenSilently({ audience, scope });
  const [endpoint, req = {}] = args;

  const res = await fetch(endpoint, {
    ...req,
    method: req.method ?? 'GET',
    headers: {
      ...req.headers,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: req.body ? JSON.stringify(req.body) : undefined
  });

  if (!res.ok) {
    let data: { message: string, reason?: string };

    try {
      data = await res.json();
    }
    catch (e) {
      // todo API should return JSON responses, warn if not
      console.warn(`Failed to parse JSON error response: ${e.message}`);
    }

    throw new ApiError(res.status, data || { message: res.statusText || `HTTP error: ${res.status}` });
  }

  try {
    return await res.json();
  }
  catch (e) {
    // todo API should return JSON responses, warn if not
    console.warn(`Failed to parse JSON response: ${e.message}`);
    return undefined;
  }
}

function useAuthenticatedFetch() {
  const { getAccessTokenSilently } = useAuth0();
  return async (...args: any) => await fetchWithTokenAsync(getAccessTokenSilently, ...args);
}

export default useAuthenticatedFetch;